import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Graphics } from '@inlet/react-pixi';
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { useDrawTagCircle } from 'components/powerFlowShared/hooks/useDrawTagCircle';
import { flowNodeColor } from 'fable/flowEditor';
import { hexStringToNumber } from 'fable/flowEditor/components/flowManager/canvas/renderers/common/colors';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import TagsModal from '../../../containers/modals/tags';
const translatePayload = (node) => {
    const { next_node_id } = node.payload;
    return next_node_id
        ? [
            {
                id: uuid(),
                label: 'arrow',
                connection: next_node_id,
            },
        ]
        : [];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { next_node_id: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const TagsNodeAttributes = {
    iconName: 'tag',
    label: 'Tags',
    helpText: 'Automatically apply custom tags to gain insights about your customer conversations (e.g. identify your VIP customers). ',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: TagsNode,
    ActionModal: TagsModal,
};
export function TagsNode({ node, context }) {
    const { payload } = node;
    const { extraData } = context;
    const { tags } = extraData;
    const { tag_ids } = payload;
    const resolvedTags = useMemo(() => {
        if (tags.length) {
            return tags.filter(({ name }) => tag_ids.indexOf(name) > -1);
        }
        // In case we can't resolve the tags using the names from the API, we can fall back to showing
        // the name that we have in the node payload without color, instead of showing 'unknown tag'.
        return tag_ids.map((name) => ({
            id: name,
            name,
            type: 'conversation',
            usage_count: 0,
        }));
    }, [tags, tag_ids]);
    const [firstTag] = resolvedTags;
    const drawTagCircle = useDrawTagCircle(firstTag, { x: 5, y: 12 });
    return (_jsxs(_Fragment, { children: [_jsx(Graphics, { draw: drawTagCircle }), _jsx(TextContent, Object.assign({ width: 200, offset: { x: 15, y: 0 } }, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: (firstTag === null || firstTag === void 0 ? void 0 : firstTag.name) || 'unknown tag' }) })), [firstTag]) })), _jsx(TextContent, Object.assign({ width: 230, offset: { x: 200, y: 0 } }, { children: useMemo(() => {
                    if (resolvedTags.length < 2) {
                        return _jsx(_Fragment, {});
                    }
                    return (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "normal", text: `+${resolvedTags.length - 1}` }) }));
                }, [resolvedTags.length]) }))] }));
}
